import { ActionContext, ActionTree } from 'vuex';
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import State from './state';
import RootState from '../../state';
import { SET_EVENTS_DATA, SET_UPDATE_SHORTLISTED_EVENT_DATA } from './mutation-types'
import eventsService from '../../../services/eventsService';
import { IGetEventsOutput } from '../../../models/interfaces/iGetEventsOutput';
import { GetEventsOutput } from '../../../models/classes/getEventsOutput';

const actions: ActionTree<State, RootState> = {
  getUpcomingEventsData({ commit, state }: ActionContext<State, RootState>, data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const params: IGetEventsOutput = new GetEventsOutput({
        orgKey: !!data && data.orgKey ? data.orgKey : state.orgKey,
        eventType: !!data && data.eventType ? data.eventType : state.eventType,
        isAts: !!data && data.isAts !== undefined ? data.isAts : state.isAts,
      });

      eventsService.getUpcomingEvents(params).then((rsp: any) => {
        commit(SET_EVENTS_DATA, camelizer.convert(rsp.data.upcoming_events));
        resolve(rsp);
      });
    });
  },
  updateShortlistedEvent({ commit, state }: ActionContext<State, RootState>, data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const params: IGetEventsOutput = new GetEventsOutput({
        orgKey: !!data && data.orgKey ? data.orgKey : state.orgKey,
        eventType: !!data && data.eventType ? data.eventType : state.eventType,
        eventKey: !!data && data.eventKey ? data.eventKey : state.eventKey,
        isAts: !!data && data.isAts !== undefined ? data.isAts : state.isAts,
      });

      eventsService.updateShortlistedEvent(params).then((rsp: any) => {
        commit(SET_UPDATE_SHORTLISTED_EVENT_DATA, camelizer.convert(rsp.data.upcoming_events));
        resolve(rsp);
      });
    });
  },

};

export default actions;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/events/actions.ts